import { Button } from "@lyfegen-platform/react-common";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

export const AddButton = () => {
	const { t } = useTranslation();
	const { push } = useHistory();

	const handleClick = () => {
		push("/simulator/create");
	};

	return (
		<Button use="primary" color="primary" onClick={handleClick}>
			{t("create")}
		</Button>
	);
};
